import { PAY_IN } from "../../../presentation/resources/constantsManager";
import { CURRENT_TRANSACTION_TAB } from "../constants/reduxConstants";

export const currentTabReducer = (
  state = {
    currentTab: PAY_IN,
  },
  { type, payload }
) => {
  switch (type) {
    case CURRENT_TRANSACTION_TAB:
      return {
        ...state,
        currentTab: payload,
      };
    default:
      return state;
  }
};
